var map = {
	"./__icon_BDE.svg": "6bb5",
	"./__icon_BUS.svg": "c2b6",
	"./__icon_BUS_CHŁODNIA.svg": "64c8",
	"./__icon_BUS_EKSPRES.svg": "9712",
	"./__icon_BUS_IZOTERMA.svg": "a2fb",
	"./__icon_BUS_SKRZYNIA.svg": "c11f",
	"./__icon_BUS_WINDA.svg": "9d4c",
	"./__icon_CHŁODNIA.svg": "0254",
	"./__icon_CIĄGNIK_SIODŁOWY.svg": "c7bd",
	"./__icon_COILMULDE.svg": "9252",
	"./__icon_CYSTERNA GAZOWA.svg": "a541",
	"./__icon_CYSTERNA_CHEMIA.svg": "1a66",
	"./__icon_CYSTERNA_PALIWOWA.svg": "fc56",
	"./__icon_CYSTERNA_SILOS.svg": "b860",
	"./__icon_CYSTERNA_SPOŻYWCZA.svg": "81c7",
	"./__icon_DŁUŻYCA.svg": "84ae",
	"./__icon_FIRANKA.svg": "6921",
	"./__icon_HAKOWIEC.svg": "a303",
	"./__icon_HAKÓWKA.svg": "2786",
	"./__icon_INNA_CYSTERNA.svg": "7197",
	"./__icon_IZOTERMA.svg": "12dc",
	"./__icon_JOLODA.svg": "97f9",
	"./__icon_JUMBO.svg": "49ff",
	"./__icon_LAWETA.svg": "26a9",
	"./__icon_MANY_TYPES.svg": "55f9",
	"./__icon_MEGA.svg": "2e08",
	"./__icon_NISKOPODŁOGOWY.svg": "601b",
	"./__icon_PLATFORMA.svg": "66de",
	"./__icon_PODKONTENEROWA_CYSTERNA.svg": "0e0b",
	"./__icon_PODKONTENEROWA_CYSTERNA_20.svg": "975b",
	"./__icon_PODKONTENEROWA_CYSTERNA_40.svg": "e534",
	"./__icon_PODKONTENEROWA_STANDARD.svg": "e3c2",
	"./__icon_PODKONTENEROWA_STANDARD_20.svg": "912a",
	"./__icon_PODKONTENEROWA_STANDARD_40.svg": "8ef7",
	"./__icon_PODKONTENEROWA_STANDARD_45.svg": "1cb9",
	"./__icon_STANDARD.svg": "6198",
	"./__icon_SWAPBODY.svg": "f6a9",
	"./__icon_SZTYWNA ZABUDOWA.svg": "dd9c",
	"./__icon_TANDEM ZESTAW.svg": "c28e",
	"./__icon_WALKINGFLOOR .svg": "2d26",
	"./__icon_WYWROTKA.svg": "dfff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";